import React, {useEffect, useState} from "react";
import {Typography} from "../../../../designSystem/components/Typography";
import {OptionButton} from "../../../../designSystem/components/OptionButton";

import {QUESTIONS} from "../../model/questions";
import {calculateBsrsScore} from "../../model/scoring";
import {BSRS_VALUES, SEVERITY_LABELS} from '../../model/scale';

export const BsrsForm = ({ onChangeAnswer }) => {
  const [answers, setAnswers] = useState<number[]>(new Array(QUESTIONS.length).fill(0));

  const totalScore = calculateBsrsScore(answers);

  const handleChange = (index: number, value: number) => {
    const updatedAnswers = [...answers];
    updatedAnswers[index] = value;
    setAnswers(updatedAnswers);
  };

  useEffect(() => {
    onChangeAnswer(answers, totalScore);
  }, [answers])

  return (
    <div className="flex flex-col gap-2">
      <Typography variant="title">
        BSRS-5 簡短健康量表
      </Typography>

      <Typography variant="bodyBold">
        請根據您過去一週的狀況，回答以下問題：
      </Typography>

      {QUESTIONS.map((question, index) => (
        <div key={index} className="flex flex-col mb-4">
          <Typography variant="body">
            {question}
          </Typography>
          <div className="flex space-x-2 mt-2">
            {BSRS_VALUES.map((value) => (
              <OptionButton
                key={`radioButton${value}`}
                isSelected={answers[index] === value}
                label={SEVERITY_LABELS[value]}
                onClick={() => handleChange(index, value)}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
